export const LOADAREAS_START = 'react/areas/LOADAREAS_START';
export const LOADAREAS_COMPLETE = 'react/areas/LOADAREAS_COMPLETE';
export const LOADAREAS_ERROR = 'react/areas/LOADAREAS_ERROR';
export const CHANGEAREAS = 'react/areas/CHANGEAREAS';
export const ADDAREAS = 'react/areas/ADDAREAS';
export const AREAS_DESTROY = 'react/areas/AREAS_DESTROY';

const initialState = {
  list: [],
  value: '',
  loading: false
};

export default function (state = initialState, action = {}) {
  switch (action.type) {
    case LOADAREAS_COMPLETE:
      return {
        ...state,
        list: action.result.areas || [],
        loading: false
      };
    case LOADAREAS_START:
      return {
        ...state,
        loading: true
      };
    case LOADAREAS_ERROR:
      return {
        ...state,
        loading: false
      };
    case CHANGEAREAS:
      return {
        ...state,
        value: action.data
      };
    case ADDAREAS:
      try {
        return {
          ...state,
          loading: false,
          list: action.data,
        };
      } catch (err) {
        return {
          ...state,
          list: [],
        };
      }
    case AREAS_DESTROY:
      return initialState;
    default:
      return state;
  }
}

export function loadAreas(data) {
  return {
    types: [LOADAREAS_START, LOADAREAS_COMPLETE, LOADAREAS_ERROR],
    promise: (client) => client.get('/api/address/regions/' + data)
  };
}

export function changeAreas(data) {
  return {
    type: CHANGEAREAS,
    data
  };
}

export function destroyAreas() {
  return { type: AREAS_DESTROY };
}

export function addAreas(data) {
  return {
    type: ADDAREAS,
    data
  };
}



// WEBPACK FOOTER //
// ./Scripts/redux/modules/addressForm/areas.js